import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { GetUserId } from "./Utils";

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = GetUserId(); // Checking local auth token or user id

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;